export enum EnterpriseTourStep {
  CREATE_CONFIGURATION_INSTANCE = 'CREATE_CONFIGURATION_INSTANCE',
  CREATE_CONFIGURATION = 'CREATE_CONFIGURATION',
  DEFINE_WORKFLOW = 'DEFINE_WORKFLOW',
  ENV_NAV_WELCOME = 'ENV_NAV_WELCOME',
  ENV_NAV_SIDEBAR = 'ENV_NAV_SIDEBAR',
  ENV_NAV_OVERVIEW = 'ENV_NAV_OVERVIEW',
  ENV_NAV_ENDPOINTS = 'ENV_NAV_ENDPOINTS',
  ENV_NAV_RELEASE_PACKAGE = 'ENV_NAV_RELEASE_PACKAGE',
  ENV_NAV_SFTP = 'ENV_NAV_SFTP',
  ENV_NAV_DATABASE_BACKUP = 'ENV_NAV_DATABASE_BACKUP',
  ENV_NAV_PRODUCT_RVTS = 'ENV_NAV_PRODUCT_RVTS',
  ENV_NAV_SANITY_TEST = 'ENV_NAV_SANITY_TEST',
  ENV_NAV_EF_TEST = 'ENV_NAV_EF_TEST',
  ENV_NAV_COB = 'ENV_NAV_COB',
  ENV_NAV_RUNBOOK = 'ENV_NAV_RUNBOOK',
  ENV_NAV_SCHEDULES = 'ENV_NAV_SCHEDULES',
  ENV_NAV_JOBS = 'ENV_NAV_JOBS',
  ENV_NAV_CUSTOM_PACKAGE = 'ENV_NAV_CUSTOM_PACKAGE',
  ENV_NAV_SIZING_DOCUMENTS = 'ENV_NAV_SIZING_DOCUMENTS',
  ENV_NAV_ACTIVITY = 'ENV_NAV_ACTIVITY',
  ENV_NAV_INVENTORY = 'ENV_NAV_INVENTORY',
  ENV_NAV_METRICS = 'ENV_NAV_METRICS',
  ENV_NAV_UPDATE_MANAGER = 'ENV_NAV_UPDATE_MANAGER',
  ENV_NAV_LOCAL_CONFIGURATION = 'ENV_NAV_LOCAL_CONFIGURATION',
  ENV_NAV_SETTINGS = 'ENV_NAV_SETTINGS',
  ENV_NAV_DEPENDENCY_TREE = 'ENV_NAV_DEPENDENCY_TREE',
  ENV_NAV_DONE = 'ENV_NAV_DONE'
}
